import { DeepModelWalker } from './ModelWalker.js';
import { ModelSystemProperties } from './ModelSystemProperties.js';
export class ModelAvailability {
    applyModel(schema, model, typeRef) {
        let availChanges = [];
        let modelWalker = new DeepModelWalker(schema, model, typeRef);
        let propertyValue;
        while (propertyValue = modelWalker.next()) {
            if (propertyValue.property.opts.availability) {
                for (const constraint of propertyValue.property.opts.availability) {
                    if (!constraint.evaluate(model)) {
                        ModelSystemProperties.addToUnAvailability(propertyValue);
                        propertyValue.parent.value[propertyValue.property.name] = undefined;
                    }
                    else {
                        let value = ModelSystemProperties.removeFromUnAvailability(propertyValue);
                        if (value) {
                            propertyValue.parent.value[propertyValue.property.name] = value;
                            availChanges.push(propertyValue);
                        }
                    }
                }
            }
        }
        return [model, availChanges];
    }
}
//# sourceMappingURL=ModelAvailability.js.map